import { api, authHeader } from "../configs/axiosConfigs";

const BASE = "api/contractor/team";

const normalize = (res, fallbackMessage) => {
  const isSuccess = res?.isSuccess ?? res?.IsSuccess;
  if (isSuccess === false) {
    return {
      isSuccess: false,
      data: null,
      message: res?.message ?? res?.Message ?? fallbackMessage,
      statusCode: res?.statusCode ?? res?.StatusCode,
    };
  }
  return {
    isSuccess: true,
    data: res?.data ?? res?.Data ?? null,
    message: res?.message ?? res?.Message,
  };
};

const ContractorTeamApi = {
  getContext: async () => {
    const response = await api.request({
      url: `${BASE}/context`,
      method: "GET",
      headers: authHeader(),
    });
    return normalize(response.data, "دریافت اطلاعات حساب ناموفق بود.");
  },

  getMembers: async () => {
    const response = await api.request({
      url: `${BASE}/members`,
      method: "GET",
      headers: authHeader(),
    });
    return normalize(response.data, "دریافت لیست تیم ناموفق بود.");
  },

  inviteMember: async (payload) => {
    const response = await api.request({
      url: `${BASE}/members`,
      method: "POST",
      data: payload,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return normalize(response.data, "دعوت کارشناس ناموفق بود.");
  },

  updateMember: async (memberId, payload) => {
    const response = await api.request({
      url: `${BASE}/members/${memberId}`,
      method: "PUT",
      data: payload,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return normalize(response.data, "به‌روزرسانی عضو ناموفق بود.");
  },
};

export default ContractorTeamApi;
